import { Checkbox } from "antd";
import moment from "moment";
import { isDateClosedOutForRoom } from "../../modules/isDateClosedOutForRoom";

export const CloseoutManagement = (props) => {
  const {
    dateColumns,
    currentMonth,
    selectedYear,
    closeout,
    openCloseoutModal,
    roomId,
  } = props;
  return (
    <tr>
      <td className="sticky-column">
        <strong>Closeout</strong>
      </td>
      {dateColumns.map((date) => {
        const day = moment(date, "DD MMM").date();
        const dateKey = moment(
          `${day}-${currentMonth.month() + 1}-${selectedYear}`,
          "DD-MM-YYYY"
        ).format("DD-MM-YYYY");
        const rawCloseout = closeout?.[roomId]?.[dateKey];
        const isClosedOut =
          rawCloseout &&
          (!!rawCloseout.all ||
            (Array.isArray(rawCloseout.ratePlans) &&
              rawCloseout.ratePlans.length > 0));
        return (
          <td
            key={`${roomId}-${date}-closeout`}
            className={`availability-cell ${isClosedOut ? "closed-out" : ""}`}
            style={{
              textAlign: "center",
              backgroundColor: isDateClosedOutForRoom(roomId, dateKey, closeout)
                ? "#f4e736"
                : "transparent",
            }}
          >
            <Checkbox
              checked={isClosedOut}
              onChange={() => openCloseoutModal(roomId, dateKey)}
            />
          </td>
        );
      })}
    </tr>
  );
};
